import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from './useAuth';

/**
 * Hook to check if user needs to complete onboarding
 * Returns state only (no navigation side effects)
 */
export const useOnboardingCheck = () => {
  const { user, loading: authLoading } = useAuth();

  const { data: profile, isLoading: profileLoading, isFetching } = useQuery({
    queryKey: ['onboarding-check', user?.id],
    queryFn: async () => {
      console.log('[useOnboardingCheck] Fetching profile for user:', user?.id);
      if (!user?.id) return null;
      
      const { data, error } = await supabase
        .from('profiles')
        .select('has_completed_onboarding')
        .eq('id', user.id)
        .maybeSingle();
      
      if (error) {
        console.error('[useOnboardingCheck] Error fetching profile:', error);
        throw error;
      }
      console.log('[useOnboardingCheck] Profile fetched:', data);
      return data;
    },
    enabled: !!user?.id,
    staleTime: 5 * 60 * 1000,
    refetchOnMount: false,
  });

  const needsOnboarding = profile?.has_completed_onboarding === false;
  // Only consider loading if auth is loading OR if query is enabled and actually fetching
  const isActuallyLoadingProfile = !!user?.id && (profileLoading || isFetching);
  const loading = authLoading || isActuallyLoadingProfile;
  
  console.log('[useOnboardingCheck] State:', { 
    needsOnboarding, 
    loading, 
    authLoading, 
    isActuallyLoadingProfile,
    hasProfile: !!profile 
  });

  return {
    needsOnboarding,
    loading,
  };
};
